import { PropsWithChildren } from 'react'

export const Loading: React.FC<PropsWithChildren> = ({ children }) => {
  return <div>
    {/* TODO: Add a loading spinner */}
    {children}
  </div>
}